import React from "react";
import Container from "./styled";
import { IoClose } from "react-icons/io5";

export default function ReferidosStepOne({ handleClose, nextStep }) {
  return (
    <Container className="topInOpacity5">
      <div className="closeButtonContainer">
        <a onClick={handleClose}>
          <IoClose />
        </a>
      </div>
      <h3>¡Aprovechá nuestro programa de referidos!</h3>
      <p>Si tus amigos aseguran su Bici con nosotros,</p>
      <p>¡tenés premios exclusivos!</p>
      <img
        alt="Premios exclusivos ilustración"
        src="images/referidos/popup.svg"
      ></img>
      <button onClick={nextStep}>¡Quiero referir!</button>
    </Container>
  );
}
